var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_281",
    "data-name": "Raggruppa 281",
    transform: "translate(-2350 -9441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_280",
    "data-name": "Raggruppa 280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_279",
    "data-name": "Raggruppa 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_276",
    "data-name": "Raggruppa 276",
    transform: "translate(-1587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_762",
    "data-name": "Tracciato 762",
    d: "M2822.4,64h307.2a38.4,38.4,0,0,1,38.4,38.4V409.6a38.4,38.4,0,0,1-38.4,38.4H2822.4a38.4,38.4,0,0,1-38.4-38.4V102.4A38.4,38.4,0,0,1,2822.4,64Z",
    transform: "translate(1153 9377)",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_763",
    "data-name": "Tracciato 763",
    d: "M3025.12,417.28a20.986,20.986,0,1,0,0-41.971h-3.19a20.986,20.986,0,1,1,0,41.971Z",
    transform: "translate(1153 9377)",
    fill: "#ee1d52",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_764",
    "data-name": "Tracciato 764",
    d: "M3021.65,375.309h-3.19a20.986,20.986,0,1,0,0,41.971h3.19a20.986,20.986,0,1,1,0-41.971Z",
    transform: "translate(1153 9377)",
    fill: "#69c9d0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_765",
    "data-name": "Tracciato 765",
    d: "M2860.8,376.46V365.824h38.54l-3.48,10.924h-10.14v40.244h-12.46V376.46Zm102.01,0V365.824h38.54l-3.47,10.924h-10.15v40.244h-12.46V376.46Zm-55.07-10.636a6.037,6.037,0,1,0,6.09,6.036A6.057,6.057,0,0,0,2907.74,365.824Zm6.09,16.386h-12.17v34.782h12.17Zm5.22,34.782V365.824h12.17v23.857l12.17-12.073h14.78l-15.36,14.95,17.1,24.722h-13.04l-11.88-16.962-3.77,3.452v13.222Zm131.28,0V365.824h12.17v23.857l12.18-12.073h14.78l-15.36,14.95,17.1,24.722h-13.05l-11.88-16.962-3.77,3.452v13.222Zm-7.24-20.7a21.071,21.071,0,0,1-21.16,20.985h-.29a20.986,20.986,0,1,1,0-41.971h.29A21.072,21.072,0,0,1,3043.09,396.3Zm-21.3-10.2a10.205,10.205,0,1,0,10.29,10.2A10.247,10.247,0,0,0,3021.79,386.092Z",
    transform: "translate(1153 9377)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_766",
    "data-name": "Tracciato 766",
    d: "M3031.55,188.7a102.273,102.273,0,0,0,59.65,19.077V165a60.381,60.381,0,0,1-12.53-1.311v33.674a102.3,102.3,0,0,1-59.65-19.077v87.3a79.13,79.13,0,0,1-123.15,65.7A79.123,79.123,0,0,0,3031.55,276V188.7ZM3047,145.543a59.607,59.607,0,0,1-15.45-34.907v-5.5h-11.87A59.907,59.907,0,0,0,3047,145.543ZM2923.51,297.771a36.193,36.193,0,0,1,39.78-56.371V197.666a79.89,79.89,0,0,0-12.52-.721v34.041a36.18,36.18,0,0,0-27.26,66.785Z",
    transform: "translate(1153 9377)",
    fill: "#ee1d52",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_767",
    "data-name": "Tracciato 767",
    d: "M3019.03,178.286a102.242,102.242,0,0,0,59.64,19.077V163.689A59.906,59.906,0,0,1,3047,145.543a59.907,59.907,0,0,1-27.32-40.409H2988.5V276a36.192,36.192,0,0,1-64.99,21.775,36.184,36.184,0,0,1,27.26-66.786V196.945a79.063,79.063,0,0,0-54.9,134.339,79.138,79.138,0,0,0,123.16-65.7Z",
    transform: "translate(1153 9377)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_768",
    "data-name": "Tracciato 768",
    d: "M3078.67,163.689v-9.1a59.689,59.689,0,0,1-31.67-9.042A59.828,59.828,0,0,0,3078.67,163.689Zm-58.99-58.555c-.29-1.628-.5-3.266-.66-4.912v-5.5h-43.05V265.585a36.206,36.206,0,0,1-52.47,32.186,36.2,36.2,0,0,0,65-21.774V105.134Zm-68.91,91.811v-9.693a79.9,79.9,0,0,0-10.86-.736,79.069,79.069,0,0,0-44.04,144.766,79.062,79.062,0,0,1,54.9-134.337Z",
    transform: "translate(1153 9377)",
    fill: "#69c9d0",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.8aa0dbb784e4df78662f23e6cd629f47.svg";
export { ForwardRef as ReactComponent };